import React from "react";
import PropTypes from "prop-types";
import { cn } from "../../utils/classNames";
import { normalizeSeasonNumber } from "../../utils/showFields";

const SeasonBadge = React.forwardRef(
  ({ seasonNumber, part = null, variant = "default", className, ...props }, ref) => {
    const normalizedSeasonNumber = normalizeSeasonNumber(seasonNumber);

    const getSeasonInfo = (num, currentVariant) => {
      if (num === null) {
        return null;
      }
      // An announced part ("Part 2") follows its season; it's never a new series.
      if (currentVariant === "compact") {
        if (part) return `Season ${num} · ${part}`;
        return num === 1 ? "New series" : `Season ${num}`;
      }
      const season = `Season ${num}`;
      return part ? `${season} · ${part}` : season;
    };

    const seasonInfo = getSeasonInfo(normalizedSeasonNumber, variant);
    if (!seasonInfo) {
      return null;
    }

    // One style means "Season N", another means "new series" (the same look
    // as the NEW tag on posters, RatingBadge "new").
    const isNewSeries = variant === "compact" && !part && normalizedSeasonNumber === 1;
    const container = isNewSeries
      ? "px-2 py-1 border border-foreground/10 bg-background/90 rounded-md"
      : "px-2 py-1 border border-border bg-muted rounded-md";

    return (
      <div
        ref={ref}
        className={cn(
          "flex items-center",
          container,
          className
        )}
        {...props}
      >
        <span className="text-badge-count text-foreground">
          {seasonInfo}
        </span>
      </div>
    );
  }
);

SeasonBadge.displayName = "SeasonBadge";

SeasonBadge.propTypes = {
  seasonNumber: PropTypes.number,
  part: PropTypes.string,
  variant: PropTypes.oneOf(["default", "compact"]),
  className: PropTypes.string,
};

export default SeasonBadge;
